(function () {
  const controllers = new Set();

  function normalizeVariantId(variantId) {
    if (!variantId) return '';
    return String(variantId).split('/').pop();
  }

  function getDeliveryLabelElements() {
    return document.querySelectorAll('[data-bf-delivery-label]');
  }

  function renderDeliveryText(text) {
    const value = text || '';

    getDeliveryLabelElements().forEach((element) => {
      // Trusted theme/locale HTML (e.g. <strong>date range</strong>).
      element.innerHTML = value;
    });
  }

  function initSupplierRoot(root) {
    if (root.dataset.bfSupplierInitialized === 'true') return;

    const mapElement = root.querySelector('[data-bf-supplier-map]');
    const sellerRow = root.querySelector('[data-bf-seller-row]');
    const noSellerRow = root.querySelector('[data-bf-no-seller]');
    const openButton = root.querySelector('[data-bf-supplier-open]');
    const sellerNameElement = root.querySelector('[data-bf-supplier-name]');
    const modalId = root.dataset.bfSupplierModalId;
    const aboutLabel = root.dataset.bfAboutLabel || '';
    const shopifySection = root.closest('.shopify-section');

    const modal =
      (modalId && document.getElementById(modalId)) ||
      root.querySelector('[data-bf-supplier-modal]') ||
      document.querySelector(`[data-bf-supplier-modal="${modalId}"]`);

    if (
      !mapElement ||
      !sellerRow ||
      !noSellerRow ||
      !openButton ||
      !sellerNameElement ||
      !modal
    ) {
      return;
    }

    root.dataset.bfSupplierInitialized = 'true';

    let supplierMap = {};

    try {
      supplierMap = JSON.parse(mapElement.textContent);
    } catch (error) {
      console.error('Supplier data could not be parsed.', error);
      return;
    }

    const modalInformationElement = modal.querySelector(
      '[data-bf-supplier-information]'
    );
    const modalLogoElement = modal.querySelector('[data-bf-supplier-logo]');
    const modalHeadingNameElement = modal.querySelector(
      '[data-bf-supplier-heading-name]'
    );

    if (
      !modalInformationElement ||
      !modalLogoElement ||
      !modalHeadingNameElement
    ) {
      return;
    }

    function closeModal() {
      if (typeof modal.hide === 'function' && modal.hasAttribute('open')) {
        modal.hide();
      }
    }

    function renderSupplier(variantId) {
      const supplierData = supplierMap[normalizeVariantId(variantId)];

      if (!supplierData || !supplierData.name) {
        sellerRow.hidden = true;
        noSellerRow.hidden = false;
        sellerNameElement.textContent = '';
        // Keep BF_DELIVERY_TEXT / USP labels — do not clear shared delivery nodes.
        closeModal();
        return;
      }

      sellerRow.hidden = false;
      noSellerRow.hidden = true;
      sellerNameElement.textContent = supplierData.name;
      if (supplierData.deliveryText) {
        renderDeliveryText(supplierData.deliveryText);
      }

      openButton.setAttribute(
        'aria-label',
        `${aboutLabel} ${supplierData.name}`.trim()
      );

      if (supplierData.logoUrl) {
        modalLogoElement.src = supplierData.logoUrl;
        modalLogoElement.alt = supplierData.name;
        modalLogoElement.hidden = false;
        modalHeadingNameElement.hidden = true;
      } else {
        modalLogoElement.removeAttribute('src');
        modalLogoElement.alt = '';
        modalLogoElement.hidden = true;
        modalHeadingNameElement.textContent = supplierData.name;
        modalHeadingNameElement.hidden = false;
      }

      modalInformationElement.innerHTML = supplierData.informationHtml || '';
    }

    const controller = {
      renderSupplier,
    };

    controllers.add(controller);

    document.addEventListener('shopify:section:unload', (event) => {
      if (shopifySection && shopifySection === event.target) {
        modal.remove();
        controllers.delete(controller);
      }
    });

    const initialVariantId = root.dataset.bfInitialVariant;
    if (initialVariantId) {
      controller.renderSupplier(initialVariantId);
    }
  }

  function handleVariantChange(variantId) {
    if (!variantId) return;

    controllers.forEach((controller) => {
      controller.renderSupplier(variantId);
    });
  }

  function onVariantPickerChange(event) {
    const picker = event.target.closest('variant-radios, variant-selects');
    if (!picker?.currentVariant?.id) return;

    handleVariantChange(picker.currentVariant.id);
  }

  function boot() {
    document.querySelectorAll('[data-bf-supplier-root]').forEach(initSupplierRoot);
  }

  document.addEventListener('change', onVariantPickerChange);

  window.addEventListener('popstate', () => {
    const variantId = new URL(window.location.href).searchParams.get('variant');
    handleVariantChange(variantId);
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
      handleVariantChange(payload?.data?.variant?.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
